// extracted by mini-css-extract-plugin
module.exports = {"pageCountWrap":"pageSearch_pageCountWrap__ZSc3c","container":"pageSearch_container__2Q3At"};